import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Container,
  Divider,
} from "@mui/material";
import ewlogofi from "./images/ewlogofi.png"
import GibsonScrum from "./images/GibsonScrum.png"
import GervaseThumb from "./images/GervaseThumb.png"
import AflThumb1 from "./images/AFLThumb1.jpeg"

const defaultArticles = [
  {
    title: "10 Rule-5 Eligible Pitchers Ranked by PS Score",
    author: "Isaac Stevens",
    date: "November 28th, 2025",
    preview:
      "Isaac Stevens of Blake Street Banter analyzes the top 10 Rule-5 eligible pitchers ranked by PS Score. These pitchers have flashed intriguing peripherals in the minors and could provide value to teams looking for bullpen help or rotation depth. Using Prospect Savant's advanced metrics, Stevens does a deep dive into each pitcher's makeup and potential.",
    imageUrl:
      "https://images2.minutemediacdn.com/image/upload/c_crop,x_0,y_0,w_5668,h_3188/c_fill,w_720,ar_16:9,f_auto,q_auto,g_auto/images/GettyImages/mmsport/134/01k3m9ynbagq2pcfjje7.jpg",
    link: "/article/12",
    source: "Blake Street Banter / Prospect Savant"
  },
  {
    title: "Prospect Savant goes to the Arizona Fall League - Who I'm Watching",
    author: "Duke Hill",
    date: "November 5th, 2025",
    preview:
      "The Arizona Fall League offers a great opportunity to get some new statcast data on some of the game's top prospects as well as some lesser known players. While I do love to dive into the data, there's something special about seeing these players in person and getting a feel for their skills beyond just the numbers. In this article, I'll share who I'm watching in the AFL and what I'm hoping to learn from seeing them play live.",
    imageUrl:
      AflThumb1,
    link: "/article/11",
    source: "Prospect Savant Original"
  },
  {
    title: "Extension and Perseverance: How 6'10\" D3 Walk-On Paul Gervase Pitched His Way to the Los Angeles Dodgers",
    author: "Duke Hill",
    date: "September 7th, 2025",
    preview:
      "Prospect Savant breaks down the Paul Gervase's journey to the majors and his extension, both very long. All quotes in this article are excerpted from this exclusive interview with Paul Gervase, conducted September 2nd, 2025. Watch the full conversation to hear directly from the Dodgers' rising pitching prospect about his unconventional journey to the majors.",
    imageUrl:
      GervaseThumb,
    link: "/article/9",
    source: "Prospect Savant Original"
  },
  {
    title: "From Undrafted to Unhittable: Trey Gibson's Bet on Himself Leads to Top 100 Prospect Status",
    author: "Duke Hill",
    date: "August 24th, 2025",
    preview:
      "Prospect Savant analyzes Orioles prospect Trey Gibson's improbable journey from an undrafted free agent to a top-100 prospect. Featuring exclusive insights from his first Harbor Park media scrum and a deep dive into the data-driven arsenal that has made him one of the most dominant pitchers in the minors.",
    imageUrl:
      GibsonScrum,
    link: "/article/8",
    source: "Prospect Savant Original"
  },
  {
    title: "\"Who'd We Get?\" - A Recap of the Red Sox Trade Deadline",
    author: "Griffey Geiss (@ggeiss_mlb)",
    date: "August 17th, 2025",
    preview:
      "Griffey Geiss (@ggeiss_mlb) breaks down the Red Sox deadline moves as part of the \"Who'd We Get?\" series on Prospect Savant.",
      imageUrl:
      "https://platform.overthemonster.com/wp-content/uploads/sites/120/2025/08/gettyimages-2228850931.jpg?quality=90&strip=all&crop=0%2C0%2C100%2C100&w=2400",
    link: "/article/7",
    source: "@GGEISS_MLB / Prospect Savant"
  },
  {
    title: "\"Who'd We Get?\" - A Recap of the Red Sox Trade Deadline",
    author: "Alex Carver",
    date: "August 16th, 2025",
    preview:
      "Alex Carver of Fish on the Farm breaks down the Twins deadline moves as part of the \"Who'd We Get?\" series on Prospect Savant.",
      imageUrl:
      "https://img.mlbstatic.com/mlb-images/image/upload/ar_16:9,g_auto,q_auto:good,w_1536,c_fill,f_jpg/mlb/ppuzezdmvfhmih35gxyb",
    link: "/article/6",
    source: "Fish on the Farm / Prospect Savant"
  },
  {
    title: "\"Who'd We Get?\" - A Recap of the Minnesota Twins Trade Deadline",
    author: "Nathan Skidmore",
    date: "August 15th, 2025",
    preview:
      "Nathan Skidmore of The Dishwasher breaks down the Twins deadline moves as part of the \"Who'd We Get?\" series on Prospect Savant.",
      imageUrl:
      "https://i.ytimg.com/vi/tWq2w9j1rAk/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLA-sWIlRPTpxDbN5hy4A_FXneZ7Eg",
    link: "/article/5",
    source: "The Dishwasher / Prospect Savant"
  },
  {
    title: "\"Who'd We Get?\" - An Arizona Diamondbacks Trade Deadline Recap",
    author: "@dbacksprospectz on X",
    date: "August 11th, 2025",
    preview:
      "@dbacksprospectz on X breaks down the Diamondbacks deadline moves as part of the \"Who'd We Get?\" series on Prospect Savant.",
      imageUrl:
      "https://arizonasports.com/wp-content/uploads/2025/09/GettyImages-2232877847-e1757375434569.jpg",
    link: "/article/4",
    source: "@dbacksprospectz on X / Prospect Savant"
  },
  {
    title: "\"Who'd We Get?\" - A Rockies Trade Deadline Recap",
    author: "Isaac Stevens",
    date: "August 11th, 2025",
    preview:
      "Isaac Stevens of Blake Street Banter breaks down the Rockies deadline moves as part of the \"Who'd We Get?\" series on Prospect Savant.",
      imageUrl:
      "https://img.mlbstatic.com/mlb-images/image/upload/ar_16:9,g_auto,q_auto:good,w_1024,c_fill,f_jpg/mlb/ypvwwihjikdupffhskum",
    link: "/article/3",
    source: "Blake Street Banter / Prospect Savant"
  },
  {
    title: "\"Who'd We Get?\" - A Recap of the Giants Trade Deadline",
    author: "Jackson Oleyar",
    date: "August 6th, 2025",
    preview:
      "The San Francisco Giants opted to move on from several key players at the trade deadline. Jackson Oleyar breaks down the Giants' deadline moves as part of the \"Who'd We Get?\" series on Prospect Savant.",
      imageUrl:
      "https://assets.sfstandard.com/image/994911177489/image_a5hgt021l15gn4kt1ri1p30872/-S3840x2560-FPNG",
    link: "/article/10",
    source: "Prospect Savant"
  },
  {
    title: "\"Who'd We Get?\" - A Recap of the Orioles Trade Deadline",
    author: "Nathan Skidmore",
    date: "August 5th, 2025",
    preview:
      "The Orioles fully committed to this year’s trade deadline and moved everything that wasn’t nailed down or on the injured list. Nathan Skidmore of The Dishwasher breaks down the Orioles deadline moves as part of the \"Who'd We Get?\" series on Prospect Savant.",
      imageUrl:
      "https://s.yimg.com/ny/api/res/1.2/iA1UC48gyBGH_LJnMqn03g--/YXBwaWQ9aGlnaGxhbmRlcjt3PTY0MDtoPTM5MDtjZj13ZWJw/https://media.zenfs.com/en/ny_post_sports_articles_389/34c72b9d541c51c6a80272e8462f41bf",
    link: "/article/2",
    source: "The Dishwasher / Prospect Savant"
  },
    {
    title: "Yankees bolster depth by adding Amed Rosario from Nationals for Clayton Beeter, prospect",
    author: "Brendan Kuty, Chris Kirschner and more",
    date: "July 27, 2025",
    preview:
      "Brendan Kuty and Chris Kirschner recap the Nationals' trade of Amed Rosario to the Yankees for Clayton Beeter and Browm Martinez. They analyze Beeter's strikeout rate percentile using Prospect Savant.",
    imageUrl:
      "https://static01.nyt.com/athletic/uploads/wp/2025/07/26222143/GettyImages-2218687517-scaled-e1753582929967-1024x683.jpg?width=770&quality=70&auto=webp",
    link: "https://www.nytimes.com/athletic/6517633/2025/07/26/yankees-amed-rosario-trade-nationals/",
    source: "New York Times (The Athletic)"
  },
  {
    title: "Effectively Wild Episode 2353: Wouldn’t Trade Him for the World",
    author: "Ben Lindbergh, Meg Rowley, Ben Clemens",
    date: "July 26, 2025",
    preview:
      "Episode features a mention of Prospect Savant. Ben Lindbergh, Meg Rowley, and Ben Clemens banter about the FanGraphs crowdsourced trade value tool, the Josh Naylor, Ryan McMahon, and Gregory Soto trades, the outlook for Eugenio Suárez, the fascinating Spencer Jones, and the lack of production by MLB rookies this season, then (58:30) discuss Other Ben’s player rankings for the fourth annual trade value series (plus a Nick Kurtz update).",
    imageUrl:
      ewlogofi,
    link: "https://blogs.fangraphs.com/effectively-wild-episode-2353-wouldnt-trade-him-for-the-world/",
    source: "FanGraphs"
  },
  {
    title: "Yankees Prospect's Hot Streak Coming at Perfect Time",
    author: "Jack Markowski",
    date: "July 22, 2025",
    preview:
      "Jack Markowski of Sports Illustrated analyzes Spencer Jones' superb batted ball data using Prospect Savant, and highlights his recent hot streak.",
    imageUrl:
      "https://images2.minutemediacdn.com/image/upload/c_crop,w_6000,h_3375,x_0,y_217/c_fill,w_1080,ar_16:9,f_auto,q_auto,g_auto/images%2FImagnImages%2Fmmsport%2Finside_the_pinstripes%2F01k0rxdhp280rhpremqv.jpg",
    link: "https://www.si.com/mlb/yankees/news/new-york-yankees-spencer-jones-hot-streak-coming-perfect-time",
    source: "Sports Illustrated"
  },
  {
    title: "Top 100 Fantasy Baseball Prospects - Dynasty Rankings for Non-Debuted Prospects (July Updates)",
    author: "Kevin Luo",
    date: "July 15th, 2025",
    preview:
      "Kevin's updated top 100 fantasy baseball prospect rankings for MLB prospects yet to debut in the majors. His July 2025 dynasty prospect rankings for fantasy baseball.",
    imageUrl:
      "https://www.rotoballer.com/wp-content/uploads/2024/03/Walker-Jenkins-Fantasy-Baseball-Rankings-Draft-Sleepers-MLB-Prospects-icon-rotoballer_edited-1220x813.jpg",
    link: "https://www.rotoballer.com/top-100-fantasy-baseball-prospect-rankings-july-updates-2025/1646652",
    source: "RotoBaller"
  },
  {
    title: "Who Will Claim the Throne? The Search for AAA’s Next King After Roman Anthony",
    author: "Duke Hill",
    date: "June 15th, 2025",
    preview:
      "Roman Anthony's historic AAA dominance has left a void - who will fill it? We break down the top contenders, from elite prospects like Samuel Basallo and Bryce Eldridge to under-the-radar mashers like Jonathon Long, to crown the next king of AAA.",
    imageUrl:
      "https://prospectsavant.com/static/media/Article1Thumb.2ef41cfb904ed5a7fff0.png",
    link: "/article/1",
    source: "Prospect Savant Original"
  },
  {
    title: "Watch Red Sox Prospect Roman Anthony Crush 497-Foot Grand Slam",
    author: "Andrew Gould",
    date: "June 8th, 2025",
    preview:
      "Andrew Gould of NESN highlights Roman Anthony's absurd 497ft grand slam, taking a look at some of his batted ball data using Prospect Savant.",
    imageUrl:
      "https://s47719.pcdn.co/wp-content/uploads/sites/5/2025/03/Roman-Anthony-1.jpg?w=1400&quot",
    link: "https://nesn.com/2025/06/watch-red-sox-prospect-roman-anthony-crush-497-foot-grand-slam/",
    source: "NESN"
  },
  {
    title: "Prospecting for Dynasty: Prospects I’m out on",
    author: "Jeff Good",
    date: "June 1st, 2025",
    preview:
      "Fantrax's Jeff Good outlines a metrics-driven framework for dynasty leagues: when to cut struggling prospects versus showing patience, using Prospect Savant trends to identify irreversible declines versus temporary slumps.",
    imageUrl:
      "https://fantraxhq.com/wp-content/uploads/2024/04/Heston-Kjerstad-Dynasty-Baseball-Stock-Watch-1.jpg",
    link: "https://fantraxhq.com/prospecting-for-dynasty-prospects-im-out-on/",
    source: "Fantrax"
  },
  {
    title: "Prospecting for Dynasty: EV90 Standouts",
    author: "Jeff Good",
    date: "May 29th, 2025",
    preview:
      "Prospect Savant recently added EV50 and EV90 stats, showing 50th and 90th percentile exit velocity numbers. Max and average are easy for quick reference, but research has found that 90th percentile EV becomes stickier faster and is more predictive than either.",
    imageUrl:
      "https://fantraxhq.com/wp-content/uploads/2020/01/MLB-Advanced-Stats-and-StatCast-Data-750x430.jpg",
    link: "https://fantraxhq.com/prospecting-for-dynasty-ev90-standouts/",
    source: "Fantrax"
  },
  {
    title: "Prospecting for Dynasty 101: Statline Scouting Prospect Savant",
    author: "Jeff Good",
    date: "May 5th, 2025",
    preview:
      "The newest tool in our belt for evaluating prospects is ProspectSavant.com, which displays statcast data for the minor leagues similar to MLB’s Baseball Savant.",
    imageUrl:
      "https://fantraxhq.com/wp-content/uploads/2025/01/Roman-Anthony-Boston-Red-Sox-Prospects-Rankings-1.jpg",
    link: "https://fantraxhq.com/prospecting-for-dynasty-101-statline-scouting-prospect-savant/",
    source: "Fantrax"
  },
  {
    title: "Brick By Brick: Building A Dynasty (Part 1)",
    author: "John Gerbino",
    date: "May 6th, 2025",
    preview:
      "John Gerbino (Gerbilsports.com) uses ProspectSavant to highlight under-the-radar prospects: Dylan Beavers' improved discipline/power and Otto Kemp's AAA tear nearing promotion. Plus Austin Gauthier's elite OBP, Drew Gilbert's advanced bat, and Jonathon Long's explosive metrics.",
    imageUrl:
      "https://static.wixstatic.com/media/0e833a_311835a0b3fc45609a59b72bfd144cf1~mv2.jpg/v1/fill/w_350,h_263,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/0e833a_311835a0b3fc45609a59b72bfd144cf1~mv2.jpg",
    link: "https://www.gerbilsports.com/post/brick-by-brick-building-a-dynasty",
    source: "Gerbil Sports"
  },
  {
    title: "Brick By Brick: Building A Dynasty (Part 2)",
    author: "John Gerbino",
    date: "May 7th, 2025",
    preview:
      "John Gerbino (Gerbilsports.com) analyzes under-the-radar prospects using ProspectSavant: Austin Martin's dramatic AAA improvements (.438 BA, 70% hard-hit), T.J. Rumfield's elite contact skills, and Ryan Vilade's hidden-gem metrics. Plus Anthony Seigler's athletic C/2B versatility and Eddys Leonard's power potential for the Braves.",
    imageUrl:
      "https://static.wixstatic.com/media/0e833a_a5f15922f62c42b49d6bb3d88bb6fcc4~mv2.png/v1/fill/w_740,h_557,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/0e833a_a5f15922f62c42b49d6bb3d88bb6fcc4~mv2.png",
    link: "https://www.gerbilsports.com/post/brick-by-brick-building-a-dynasty-1",
    source: "Gerbil Sports"
  },
  {
    title: "Brick By Brick: Building A Dynasty (Part 3)",
    author: "John Gerbino",
    date: "May 31st, 2025",
    preview:
      "John Gerbino (Gerbilsports.com) analyzes promoted prospects Henry Davis' power potential and Daylen Lile's elite contact using ProspectSavant, plus imminent call-ups: Jacob Melton's 5-tool upside, Brett Harris' power surge, Jesus Rodriguez's Yankees opportunity, and Chad Stevens' .946 AAA OPS for the Angels.",
    imageUrl:
      "https://static.wixstatic.com/media/0e833a_a00262d2d84e49c9a8d3e9a1c7c2556b~mv2.png/v1/fill/w_740,h_702,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/0e833a_a00262d2d84e49c9a8d3e9a1c7c2556b~mv2.png",
    link: "https://www.gerbilsports.com/post/brick-by-brick-building-a-dynasty-part-3",
    source: "Gerbil Sports"
  },
];

export default function Articles(props: any) {
  const articles = props.articles || defaultArticles;
  const title = props.title || "Latest Articles";

  return (
    <Container
      style={{
        padding: "24px",
        width: 1000,
        border: "#293241 solid 2px",
        boxShadow:
          "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
        maxWidth: "95%",
        backgroundColor: "#FFFFFF",
        marginBottom: "24px",
      }}
    >
      <title>Articles</title>
      <meta
            name="description"
            content="Prospect Savant - Minor League Baseball Savant"
          />
          <meta
            name="title"
            content="Prospect Savant"
          />
          <meta property="og:description" content="Prospect Savant - Minor League Baseball Savant" />
          <meta property="og:title" content="Prospect Savant" />
      <Typography
        variant="h4"
        component="h1"
        style={{
          fontWeight: "bold",
          marginBottom: "12px",
          color: "#000000",
          textAlign: "center",
          fontSize: "34pt",
        }}
      >
        {title}
      </Typography>
      <Divider variant="middle" style={{ marginBottom: "20px" }} />
      <Grid container spacing={4}>
        {articles.map((article: any) => (
          <Grid item xs={12} key={article.id}>
            <a href={article.link} style={{ textDecoration: "none" }}>
              <Card
                style={{
                  display: "flex",
                  flexDirection: props.isDesktop ? "row" : "column",
                  height: "100%",

                  borderRadius: "8px",
                  overflow: "hidden",
                }}
                sx={{
                  "&:hover": {
                    boxShadow: "0px 0px 15px rgba(31, 102, 196, 0.8)",
                    cursor: "pointer",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  style={{
                    width: props.isDesktop ? "40%" : "100%",
                    height: props.isDesktop ? "100%" : "40%",
                    objectFit: "cover",
                  }}
                  image={article.imageUrl}
                  alt={article.title}
                />
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: props.isDesktop ? "60%" : "100%",
                  }}
                >
                  <CardContent style={{ flex: "1 0 auto" }}>
                    <Typography
                      variant="h5"
                      component="h2"
                      style={{
                        fontWeight: "bold",
                        marginBottom: "8px",
                      }}
                    >
                      {article.title}
                    </Typography>

                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <Typography
                        variant="body2"
                        style={{
                          color: "rgba(0, 0, 0, 0.6)",
                          marginRight: "12px",
                        }}
                      >
                        By {article.author}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          color: "rgba(0, 0, 0, 0.6)",
                        }}
                      >
                        {article.date}
                      </Typography>
                      <Typography
                        variant="body2"
                        style={{
                          color: "rgba(0, 0, 0, 0.6)",
                          marginLeft: "10px"
                        }}
                      >
                        {article.source}
                      </Typography>
                    </Box>

                    <Typography
                      variant="body1"
                      style={{
                        color: "rgba(0, 0, 0, 0.87)",
                        marginBottom: "16px",
                      }}
                    >
                      {article.preview}
                    </Typography>
                  </CardContent>
                </Box>
              </Card>
            </a>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
